import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

import * as _ from 'lodash';
import { ServiceService } from '../../../../../../common/services/Service.service';
import { UtilityService } from 'app/common/services/Utility.service';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'settings-tickets-services',
  templateUrl: './service.component.html',
  styleUrls: ['./service.css'],
  providers: [ServiceService, BsModalService],
})
@Injectable()
export class ServicesComponent implements OnInit {
  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public list_page_devide: any = [];
  public allService: any = [];
  public model: any = {};
  public modelFilter: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public user: any;
  totalItem: any = 0;
  totalPage: any = 0;
  public allSources: any = [];

  public id_delete: number;
  public delete_ids: any = [];

  constructor(
    private serviceService: ServiceService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.loadData();

    this.allSources = [
      { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
      { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
      { id: 'chat', text: 'Tin nhắn web' },
      { id: 'hand', text: 'Thêm mới' },
      { id: 'zalo', text: 'Zalo' },
      { id: 'email', text: 'Email' },
      { id: 'facebook', text: 'Kênh Facebook' },
    ];
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.serviceService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.list = res.data.services;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = 1;

            const allService = [
              {
                id: '-1',
                text: '-- Dịch vụ cha --',
              },
            ];
            res.data.services.forEach(e => {
              allService.push({
                id: e.id,
                text: e.name,
              });
            });
            this.allService = allService;
            // this.list_page_devide = this.list.slice(parseInt(request.offset), parseInt(request.offset) + parseInt(request.limit));
            for (let i = 0; i < this.list.length; i++) {
              const ele = this.list[i];
              ele.lstChildren = [];
              for (let j = 0; j < this.list.length; j++) {
                if (this.list[j].parent_id == ele.id) {
                  ele.lstChildren.push(JSON.parse(JSON.stringify(this.list[j])));
                }
              }

              if (!ele.parent_id || ele.parent_id == '-1') {
                ele.show = true;
              } else {
                // Nếu là dịch vụ con thì kiểm tra xem có dịch vụ cha trong list trả về hay k, nếu có thì k hiển thị dịch vụ con nữa và ngược lại
                let flag = false;
                for (let m = 0; m < this.list.length; m++) {
                  if (this.list[m].id == ele.parent_id) {
                    flag = true;
                    break;
                  }
                }
                if (!flag) {
                  ele.show = true;
                } else {
                  ele.show = false;
                }
              }
              ele.showChildren = false;
            }
            console.log(this.list, '--- is this list');
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            this.allService = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  toggleService(service) {
    service.showChildren = !service.showChildren;
    if (service.lstChildren.length > 0) {
      service.lstChildren.forEach(element => {
        element.show = service.showChildren;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == element.id) {
            element.lstChildren = JSON.parse(JSON.stringify(this.list[i].lstChildren));
            element.showChildren = false;
          }
        }
      });
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  changeParentService($event) {
    this.model.parent_id = $event.value;
  }

  changeSource(e: any): void {
    this.model.source = e.value;
  }

  openModal(template: TemplateRef<any>, id?: any, parentId?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);
    this.model = { name: '', parent_id: '-1', description: '', source: [] };
    if (parentId) {
      this.model.parent_id = parentId;
    }
    this.typeModal = id ? 'edit' : 'add';

    if (id) {
      this.serviceService
        .find(id)
        .toPromise()
        .then(rs => {
          this.model = rs.data;
          if (!this.model.parent_id) {
            this.model.parent_id = '-1';
          }
          const source = this.model.source ? this.model.source.split(',').filter(element => element) : '';
          this.model.source = source;
        });
    }
  }

  add() {
    // if (!this.model.name || (this.model.name && this.model.name.trim() == "")){
    //     this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" }}
    // else if(!this.model.source || (this.model.source && this.model.source.length == 0)){
    //     this.message = { class: "alert dark alert-danger", content: "Nguồn không được bỏ trống !" };
    // }
    // else {
    const payload = {};
    if (this.model.name) {
      payload['name'] = this.model.name;
    }
    if (this.model.description) {
      payload['description'] = this.model.description;
    }
    if (this.model.parent_id != '-1') {
      payload['parent_id'] = this.model.parent_id;
    }
    if (this.model.source && this.model.source.length > 0) {
      let source = ',';
      for (let i = 0; i < this.model.source.length; i++) {
        source += this.model.source[i] + ',';
      }
      payload['source'] = source;
    } else {
      payload['source'] = '';
    }
    payload['source'] = UtilityService.trimChar(payload['source'], ',');
    this.serviceService.create(payload).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Thêm mới không thành công',
            };
            this.toastr.error('Thêm mới thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Thêm mới thành công',
            };
            this.toastr.success('Thêm mới thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadData();
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
    // }
  }

  edit(data) {
    this.message = null;
    const objectData = {};

    // if (!this.model.name || (this.model.name && this.model.name.trim() == "")){
    //     this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" }}
    // else if(!this.model.source || (this.model.source && this.model.source.length == 0)){
    //     this.message = { class: "alert dark alert-danger", content: "Nguồn không được bỏ trống !" };
    // }
    // else {
    const payload = {};
    if (this.model.name) {
      payload['name'] = this.model.name;
    }
    if (this.model.description) {
      payload['description'] = this.model.description;
    }
    if (this.model.parent_id != '-1') {
      payload['parent_id'] = this.model.parent_id;
    } else {
      payload['parent_id'] = -1;
    }
    if (this.model.source && this.model.source.length > 0) {
      let source = ',';
      for (let i = 0; i < this.model.source.length; i++) {
        source += this.model.source[i] + ',';
      }
      payload['source'] = source;
    } else {
      payload['source'] = '';
    }
    payload['source'] = UtilityService.trimChar(payload['source'], ',');
    this.serviceService.update(this.model.id, payload).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Cập nhật không thành công',
            };
            this.toastr.error('Cập nhật thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Cập nhật thành công',
            };
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
    // }
    this.scrollToTop();
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ name: this.modelFilter.keyword.trim() });
    } else {
      this.loadData();
    }
  }

  public changeType(e: any): void {
    this.model.type = e.value;
  }

  openConfirmDelete(template: TemplateRef<any>, id, name) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa dịch vụ "' + name + '" và tất cả dịch vụ con của "' + name + '" không?');
    if (y) {
      this.getAllChildServiceId(id);
      this.delete_ids.push(id);
      this.submitDelete();
    }
  }

  getAllChildServiceId(id) {
    for (let i = 0; i < this.list.length; i++) {
      if (this.list[i].id == id && this.list[i].lstChildren.length > 0) {
        const child = this.list[i].lstChildren;
        for (let j = 0; j < child.length; j++) {
          this.delete_ids.push(child[j].id);
          this.getAllChildServiceId(child[j].id);
        }
      }
    }
  }

  submitDelete() {
    this.serviceService._delete(this.delete_ids).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/service/service.component.ts